import axios from 'axios'
import router from '@/router'
import { useSnackbarStore } from '../store/snackbar'

const API_URL = import.meta.env.VITE_API
const VIA_CEP = 'https://viacep.com.br/ws'

const api = axios.create({
  headers: {
    'Content-Type': 'application/json'
  },
  baseURL: API_URL
})

api.interceptors.request.use(
  (config) => {
    const auth = localStorage.getItem('auth')
    if (auth && config.headers) {
      const session = JSON.parse(auth)
      config.headers.authorization = `Bearer ${session.AccessToken}`
      config.headers.user = session.id
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

const getNewToken = async (refreshToken: string) => {
  return api.get('/users/auth', {
    headers: {
      RefreshToken: refreshToken
    }
  })
}

const redirectToLogin = () => {
  const snackbarStore = useSnackbarStore()
  snackbarStore.showSnackbar({
    text: 'Tempo de sessão expirado',
    color: 'warning',
    timeout: 4000
  })

  localStorage.clear()
  router.replace({ name: 'Login' })
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      const auth = localStorage.getItem('auth')
      if (!auth) return redirectToLogin()

      const refreshToken = JSON.parse(auth)?.RefreshToken
      if (!refreshToken) return redirectToLogin()

      try {
        const response = await getNewToken(refreshToken)
        if (response.status !== 200) return redirectToLogin()

        const newAuth = {
          ...JSON.parse(auth),
          AccessToken: response.data.AccessToken
        }
        localStorage.setItem('auth', JSON.stringify(newAuth))

        error.config.headers['Authorization'] =
          `Bearer ${response.data.AccessToken}`
        return axios(error.config)
      } catch (err) {
        console.error('Failed to refresh token', err)
        redirectToLogin()
        return Promise.reject(err)
      }
    }

    return Promise.reject(error)
  }
)

export const viacepAPI = axios.create({
  headers: {
    'Content-Type': 'application/json'
  },
  baseURL: VIA_CEP
})

export default api
